import { render, staticRenderFns } from "./singleAdministrationChildrenFourEdit.vue?vue&type=template&id=f0bf355c"
import script from "./singleAdministrationChildrenFourEdit.vue?vue&type=script&lang=js"
export * from "./singleAdministrationChildrenFourEdit.vue?vue&type=script&lang=js"
import style0 from "./singleAdministrationChildrenFourEdit.vue?vue&type=style&index=0&id=f0bf355c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports